import React, { useEffect, useState } from "react"
import styles from "./ChartAccordion.module.css"
import Button from "@components/general/button/Button"
import Arrow from "@components/general/icons/arrow/Arrow"
import Chart from "@components/dataDisplay/chart/Chart"
import { QuotesResponse } from "@ts/interfaces/quotesResponse.interface"

const ChartAccordionBoxHeader = ({
  name,
  typeCode,
  currency,
  currentPriceFormatted,
  dailyChangeRelFormatted,
  dailyChangeAbsFormatted,
  active,
  i,
  handleArrowClick,
  displayArrow,
}: {
  name: string
  typeCode: string
  currency: string
  currentPriceFormatted: string
  dailyChangeRelFormatted: string
  dailyChangeAbsFormatted: string
  active: boolean
  i: number
  handleArrowClick: any
  displayArrow: boolean
}) => (
  <div className={styles.boxHeader} onClick={() => handleArrowClick(i)}>
    <div className={styles.boxTitle}>{name}</div>
    <div className={styles.boxPriceContainer}>
      <div className={styles.boxPrice}>
        <span>{currentPriceFormatted}</span> {typeCode !== "IND" && <span>{currency}</span>}
      </div>
      <div
        className={`${styles.boxPriceChangeRel} ${
          dailyChangeRelFormatted[0] === "-" ? styles.negative : styles.positive
        }`}
      >
        {dailyChangeRelFormatted}
      </div>
      <div
        className={`${styles.boxPriceChangeAbs} ${
          dailyChangeAbsFormatted[0] === "-" ? styles.negative : styles.positive
        }`}
      >
        {dailyChangeAbsFormatted}
      </div>
    </div>
    {displayArrow && (
      <div className={styles.boxArrow}>
        <Arrow rotation={active ? 180 : 0} />
      </div>
    )}
  </div>
)

const ChartAccordionBoxContent = ({
  active,
  wfgListingKey,
  fuwUrl,
  darkMode,
}: {
  active: boolean
  wfgListingKey: string
  fuwUrl: string
  darkMode: boolean
}) => (
  <div className={`${active ? "" : styles.boxContentclosed}`}>
    <Chart wfgListingKey={wfgListingKey} active={active} darkMode={darkMode} />
    <div className={styles.boxContentBtnGrp}>
      {fuwUrl && (
        // TODO: remove `/boerse` prefix once migrated to the new boerse frontend (paths are root-relative there)
        <Button type="link" href={`https://wp.fuw.ch/boerse${fuwUrl}`}>
          Umfassende Daten
        </Button>
      )}
    </div>
  </div>
)

const ChartAccordion = ({ quotesData }: { quotesData: QuotesResponse }) => {
  const [activeAccordionMenu, setActiveAccordionMenu] = useState(0)
  const [darkMode, setDarkMode] = useState(false)

  const messageHandler = (event: any) => {
    // No origin check so far --- if (event.origin === "https://www.fuw.ch")
    if (event.data.type === "colorMode") {
      if (event.data.mode === "dark") {
        setDarkMode(true)
        document.body.classList.add("dark")
      } else {
        setDarkMode(false)
        document.body.classList.remove("dark")
      }
    }
  }

  useEffect(() => {
    window.addEventListener("message", messageHandler)
  }, [])

  const handleArrowClick = (i: number) => {
    setActiveAccordionMenu(i)
  }

  return (
    <div>
      {quotesData.status !== undefined && quotesData.payload !== undefined && (
        <div>
          {quotesData.status === "Error" ? (
            <article className={styles.error}>
              <h1>Error</h1>
              <div>{quotesData.message}</div>
            </article>
          ) : (
            <div>
              {quotesData.payload.map((box, i) => (
                <div key={i} className={styles.box}>
                  <ChartAccordionBoxHeader
                    name={box.name}
                    typeCode={box.typeCode}
                    currency={box.currency}
                    currentPriceFormatted={box.currentPriceFormatted}
                    dailyChangeRelFormatted={box.dailyChangeRelFormatted}
                    dailyChangeAbsFormatted={box.dailyChangeAbsFormatted}
                    active={activeAccordionMenu === i}
                    i={i}
                    handleArrowClick={handleArrowClick}
                    displayArrow={quotesData.payload !== undefined ? quotesData.payload.length > 1 : false}
                  />
                  <ChartAccordionBoxContent
                    active={activeAccordionMenu === i}
                    wfgListingKey={box.wfgListingKey}
                    fuwUrl={box.fuwUrl}
                    darkMode={darkMode}
                  />
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export default ChartAccordion
